import { useEffect } from "react";
import { connect } from "react-redux";
import icon from "../../../assets/static/images/secciones/condicioneslegales.png";

import { getCondLegales } from "../../../redux/Sections/CondicionesLegales/actions";
import { Tabla } from "../../../components/Table/Table";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";

const CondicionesLegales = ({ dataList, getData }) => {
  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      title: "Contrato",
      dataIndex: "contrato",
      key: "contrato",
      width: "30%",
    },
    {
      title: "Condiciones",
      dataIndex: "condiciones",
      key: "condiciones",
      width: "20%",
    },
    {
      title: "Abogado",
      dataIndex: "abogado",
      key: "abogado",
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
    },
  ];

  function exportData(list) {
    let filename = "condiciones-legales.xlsx";

    const dataList = list.map((e) => {
      return {
        "CONTRATO": e.contrato,
        "CONDICIONES": e.condiciones,
        "ABOGADO": e.abogado,
        "MUNICIPIO ": e.municipio,
      };
    });

    let name = "Condiciones legales";

    return {
      dataList,
      filename,
      name
    };
  }

  return (
    <div className="section-container section-content">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="condiciones-legales" />
        <span>Condiciones Legales</span>
      </div>
      <div className="section-table">
        <Tabla columns={columns} dataList={dataList} />
        <div className="mt-3">
          <div style={{ maxWidth: 170 }}>
            <DescargarExcel data={exportData(dataList)} />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dataList: state.dashboard.condlegalesList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: () => dispatch(getCondLegales()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CondicionesLegales);